import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { DateField } from '@components/Fields/DateField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { Button } from '@material-ui/core';
import { IImportarRequest } from '@services/ExcedenteService';
import React from 'react';

export type ExcedenteImportarFormProps = {
    form: IForm<IImportarRequest>
    onArquivoChange: (arquivo: File) => void
}

export function ExcedenteImportarForm ({ form, onArquivoChange }: ExcedenteImportarFormProps) {
    const [fileName, setFileName] = React.useState("");
    const { fields } = form;

    const handleFileChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;

        if (fileList !== null) {
            const firstItem = fileList.item(0);

            if (firstItem != null) {
                setFileName(firstItem.name);
                onArquivoChange(firstItem);
            }
        }

    }, [onArquivoChange]);

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={4}>
                <CompetenciaField 
                    field={fields.competencia}
                    label="Competência"
                />
            </GridItem>

            <GridItem xs={4}>
                <DateField
                    field={fields.inicio}
                    label="Período De"
                />
            </GridItem>

            <GridItem xs={4}>
                <DateField
                    field={fields.termino}
                    label="Período Até"
                />
            </GridItem>

            <GridItem xs={12} style={{marginTop: 16}}>
                <input accept=".csv" id="contained-button-file" type="file" style={{display: 'none'}} onChange={handleFileChange} />
                <label htmlFor="contained-button-file">
                    <Button variant="contained" color="primary" component="span">Escolher Arquivo</Button>
                </label>
                <span style={{marginLeft: 8}}>{fileName}</span>
            </GridItem>
        </HorizontalGrid>
    )
}